import { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import Switch from "@mui/material/Switch";
import _ from "lodash";
import { Button } from "react-bootstrap";
import CardNumberFormat from "../_Components/CardNumberFormat";

function DataGrid({ data, setShowModalAccount, setSelectedAccountId }) {
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "#",
      minWidth: 50,
    },

    {
      accessor: "accountNumber",
      Header: "شماره حساب",
      minWidth: "100px",
    },
    {
      accessor: "accountOwnerName",
      Header: "صاحب حساب",
      minWidth: "130px",
    },
    {
      accessor: "cardNumber",
      Header: "شماره کارت",
      minWidth: "200px",
      Cell: ({ row }) => <CardNumberFormat number={row.original.cardNumber} />,
    },
    {
      accessor: "cardOwnerName",
      Header: "نام صاحب کارت",
      minWidth: "130px",
    },
    {
      accessor: "bank",
      Header: "نام بانک ",
      minWidth: "100px",
    },
    {
      accessor: "balance",
      Header: "موجودی ",
      minWidth: "100px",
    },
    {
      accessor: "typeS",
      Header: "نوع حساب ",
      minWidth: "100px",
    },
    {
      Header: "وضعیت",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.status ? true : false}
            //checked={state.checkedA}
            value="row.original.active"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
          // onChange={handleChange(row.original)}
          />
        </div>
      ),
    },
    {
      accessor: "createdPersianTime",
      Header: "تاریخ درج",
      minWidth: "90px",
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* ویرایش */}
          <Button
            title="ویرایش"
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedAccountId(row.original.id);
              setShowModalAccount(true);
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  return (
    <DataTable config={config} columns={columns} data={data} />
  );
}

export default DataGrid;
